//https://www.iconfinder.com/iconsets/cc_mono_icon_set
//https://github.com/madebymany/sir-trevor-js
import Vue from 'vue'
import App from './App'
import router from './router'
import VueResource from 'vue-resource'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/tr-TR'
import './assets/fonts/themify-icons/themify-icons.css';
import './assets/fonts/linea/styles.css';
import 'font-awesome/css/font-awesome.min.css';
import LeftSideComponent from './components/Base/LeftSide.vue'
import ContentHeaderComponent from './components/Base/ContentHeader.vue'
import WidgetComponent from './components/Base/Widget.vue'
import FormItemcomponent from './components/Base/FormItem.vue'
import 'bootstrap/dist/js/bootstrap';
import Auth from './auth';
import moment from 'moment'
import VueQrcode from '@chenfengyuan/vue-qrcode';


import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'

Vue.use(Viewer)

Vue.prototype.moment = moment

Vue.config.productionTip = false;
Vue.use(VueResource);

Vue.use(ElementUI, {locale});

require('./lib/pdfReport');
require('./lib/downloadBase64');

Vue.http.options.root = process.env.API_URL;

Vue.http.options.emulateJSON = true;
Vue.http.options.emulateHTTP = true;
Vue.http.options.crossOrigin = true;
Vue.http.headers.common['Access-Control-Expose-Headers'] = 'Origin, X-Requested-With, Content-Type, Accept, x-session-token, timeout, Content-Length, location, *';
Vue.http.headers.common['Access-Control-Allow-Origin'] = '*';

Vue.config.productionTip = false;
window.jQuery = window.$ = require('jquery/dist/jquery.min');

import OrganizationChart from 'vue-organization-chart'
import 'vue-organization-chart/dist/orgchart.css'

Vue.component(VueQrcode.name, VueQrcode);
Vue.component('left-side', LeftSideComponent);
Vue.component('content-header', ContentHeaderComponent);
Vue.component('widget', WidgetComponent);
Vue.component('form-item', FormItemcomponent);
Vue.component('organization-chart', OrganizationChart);

let bus = new Vue({});
Object.defineProperty(Vue.prototype, '$bus', {
  get() {
    return this.$root.bus;
  }
});

Auth.refreshUser();
Vue.http.headers.common['Authorization'] = 'Bearer ' + Auth.token;

function urlClear(url) {
  url = url.trim().replace(/\s/g, '%20');
  url = url.replace('https://', '');
  url = url.replace('http://', '');
  url = url.replace(':', '__');
  let find = '/';
  let re = new RegExp(find, 'g');
  url = url.replace(re, '-');
  return url;
}


router.beforeEach((to, from, next) => {
  Auth.refreshUser();

  let _sTop = $(window).scrollTop();
  let _sFKey = urlClear(from.path);
  let _sTKey = urlClear(to.path);

  window.localStorage.setItem('scroll' + _sFKey, _sTop);
  let _sVal = window.localStorage.getItem('scroll' + _sTKey);
  if (!_sVal) {
    _sVal = 0;
  }

  if (_sVal > 0) {
    setTimeout(function () {
      $(document).scrollTop(_sVal);
    }, 100);

  }
  window.localStorage.setItem('after_scroll', _sVal);

  let user = router.app.user;
  let roles = [];
  if (user !== undefined) {
    roles = user.roles;
  }


  if (!Auth.isLogin && to.name !== 'login') {
    next({path: '/login', query: {redirect: to.fullPath}});
  }
  if (Auth.isLogin && to.name === 'login') {
    next({path: '/'});
  }
  if (to.name === 'logout') {
    Auth.logout();
    next({path: '/login'});
  }

  if (Auth.isLogin && to.name !== 'home' && to.name !== 'login' && to.name !== 'logout') {

    let roles = JSON.parse(window.localStorage.getItem('roles'));

    if (to.meta.roles !== undefined) {

      let isOk = false;
      to.meta.roles.forEach((item, index) => {
        if (roles.indexOf(item) > -1) {
          isOk = true;
          next();
        }
      })
      if (!isOk) {
        router.push('/');
      }
    }
  }

  next();
});


// import customerBundle from './BundleCustomers'
// import antennaBundle from './BundleAntennas'
// import packageBundle from './BundlePackage'
import applicationBundle from './BundleApplication'
//
// router.addRoutes(customerBundle.routes);
// router.addRoutes(antennaBundle.routes);
// router.addRoutes(packageBundle.routes);
router.addRoutes(applicationBundle.routes);

new Vue({
  el: '#app',
  router: router,
  render: h => h(App),
  data() {
    return {
      hasNewMessage: false,
      auth: Auth,
      bus: bus,
      loader: false,
      loading: 0,
      layout: {
        ready: false,
        sideBarCollapse: false,
        searchBox: false,
        popupCollapse: false
      },
      routeRoles: [],
      user: {
        fullName: null,
        id: null,
        email: null,
        username: null,
        roles: []
      },
    }
  },
  watch: {
    loading: function () {
      this.loader = false;
      if (this.loading > 0) {
        this.loader = true;
      }
    }
  },
  created() {
    Auth.refreshUser();
    let self = this;
    Vue.http.interceptors.push(function (request, next) {
      Auth.refreshUser();
      Vue.http.headers.common['Authorization'] = 'Bearer ' + Auth.token;
      self.loading++;
      next((res) => {
        if (res.status === 401 || res.status === 400) {
          Auth.logout();
          this.$notify({
            title: 'Giriş Hatası',
            message: 'Lütfen giriş yapınız',
            type: 'error'
          });
          self.$router.push({
            name: 'logout'
          });

        }
        self.loading--;
        let _sVal = window.localStorage.getItem('after_scroll');
        if (_sVal > 0) {
          setTimeout(function () {
            $(document).scrollTop(_sVal);
          }, 200);
        }
      });
    });

    this.$bus.$on('A_LOGIN_USER', () => {
      this.getLayout();
    });

    if (Auth.isLogin) {
      this.getLayout();
    }


  },
  methods: {
    getLayout() {
      this.layout.ready = false;
      this.$http.get('layout')
        .then((response) => {
          this.user = response.body.user;
          window.localStorage.setItem('roles', JSON.stringify(this.user.roles));
          this.layout.ready = true;
        });
    },
    checkRole(keys) {
      let result = false;
      keys.forEach((item, index) => {
        if (item === 'ALL' || this.user.roles.indexOf(item) >= 0) {
          result = true;
        }
      });
      return result;
    },
  }
});



// WEBPACK FOOTER //
// ./src/main.js